<template>
  <v-layout
    :title="$t('insurancerecipe.content_title')"
    :subtitle="$t('insurancerecipe.content_subtitle')"
  >
    <template slot="navigation">
      <InsuranceAuthorizationNavigation />
    </template>
    <template slot="logo" v-if="logo_url">
      <b-img :src="logo_url" class="mw-100" />
    </template>
    <InsuranceAuthorizationRecipe v-on:recipe:done="onRecipeDone" />
  </v-layout>
</template>

<script>
import VLayout from "@/layouts/Default";
import InsuranceAuthorizationNavigation from "@/components/insuranceauthorization/InsuranceAuthorizationNavigation";
import InsuranceAuthorizationRecipe from "@/components/insuranceauthorization/InsuranceAuthorizationRecipe";
import { mapGetters } from "vuex";

export default {
  name: "insuranceauthorization-recipe-view",
  data() {
    return {
      logo_url: undefined,
    };
  },
  computed: {
    ...mapGetters("organization", ["getInsuranceDataByUUID"]),
  },
  mounted: function () {
    this.loadData();
  },
  methods: {
    putLogo(organization) {
      if (
        organization &&
        organization.configuration &&
        organization.configuration.show_form_logo
      ) {
        this.logo_url = organization.configuration.form_logo;
      }
    },
    putBreadCrumb(organization) {
      this.$store.commit("siteconf/MUTATE_BREADCRUMB", [
        {
          langkey: "breadcrumb.home",
          to: { name: "home" },
        },
        {
          langkey: "breadcrumb.refund_insurance_selection",
          to: { name: "nopatient_insuranceauthorization_insurance_selection" },
        },
        {
          langkey: "breadcrumb.insuranceauthorization_home",
          langparams: {
            insurance_name: (organization || {}).public_name || "Insurance",
          },
          to: { name: "nopatient_insuranceauthorization_home" },
        },
        {
          langkey: "breadcrumb.authorization_recipe",
          to: { name: "nopatient_insuranceauthorization_recipe" },
        },
      ]);
    },
    loadData() {
      var organization = this.getInsuranceDataByUUID(this.$route.params.i_uuid);
      if (!organization) {
        this.$store.dispatch("organization/INSURANCE_AUTHORIZATION_LIST").then(
          () => {
            organization = this.getInsuranceDataByUUID(
              this.$route.params.i_uuid
            );
            this.putBreadCrumb(organization);
            this.putLogo(organization);
          },
          (err) => {
            throw new Error(err);
            //this.consoleout(err);
          }
        );
      } else {
        this.putBreadCrumb(organization);
        this.putLogo(organization);
      }
    },
    onRecipeDone: function () {
      this.$router.push({
        name: "nopatient_insuranceauthorization_home",
        params: {
          pt_uuid: this.$route.params.pt_uuid,
          i_uuid: this.$route.params.i_uuid,
          insuranceauthorization_uuid: this.$route.params
            .insuranceauthorization_uuid,
        },
      });
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        insurancerecipe: {
          content_title: "Insurance recipe",
          content_subtitle:
            "Please fill in the data, the fields marked with * are essential",
        },
      },
    },
  },
  components: {
    VLayout,
    InsuranceAuthorizationRecipe,
    InsuranceAuthorizationNavigation,
  },
};
</script>

<style>
</style>
